import { render } from "./change_pwd.vue?vue&type=template&id=73b26392&scoped=true"
import script from "./change_pwd.vue?vue&type=script&lang=js"
export * from "./change_pwd.vue?vue&type=script&lang=js"

import "./change_pwd.vue?vue&type=style&index=0&id=73b26392&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b26392"]])

export default __exports__